/* eslint-disable sort-keys, max-lines */
import { clone } from "ramda";

const approvalLogItems = [
    {
        index: 1,
        timestamp: 1619065886495,
        data: {
            comment: "Lets rework this later, but move on for now",
            who: {
                id: "18e09fe5-c8a8-4896-b4f4-c10da9cd9ae0",
                email: "testadmin@mailtest.masterdocs.com.au",
                firstname: "Test",
                lastname: "Admin"
            },
            why: {
                human: "Initilized log on Hello Workflow (6080fc1e3365555ae94a59e5)",
                robot: {
                    related: "1",
                    relatedKind: "action",
                    action: {
                        kind: "APPROVE",
                        status: "REJECTED"
                    }
                }
            },
            what: [],
            when: 1619092521445
        },
        hash: "c80062169db44a780cc75928803d8092b8b3658ec20f901fb2fee5a3fb14b8f5"
    },
    {
        index: 2,
        timestamp: 1619065999495,
        data: {
            comment: "Looks great!",
            who: {
                id: "18e09fe5-c8a8-4896-b4f4-c10da9cd9ae0",
                email: "testadmin@mailtest.masterdocs.com.au",
                firstname: "Test",
                lastname: "Admin"
            },
            why: {
                human: "Initilized log on Hello Workflow (6080fc1e3365555ae94a59e5)",
                robot: {
                    related: "1",
                    relatedKind: "action",
                    action: {
                        kind: "APPROVE",
                        status: "FULFILLED"
                    }
                }
            },
            what: [],
            when: 1610099521445
        },
        hash: "c80062169db44a780cc75928803d8092b8b3658ec20f901fb2fee5a3fb14b8f5"
    },
];

export const requiresApproval = {
    _id: "6080fc1e3365555ae94a59e6",
    name: "Hello Workflow",
    description: "New Workflow, yay!",
    startDate: null,
    stages: [
        {
            _id: "sg-A61xEtIteGpW6aqffBKYZ",
            name: "Stage 1",
            description: "The first stage",
            nextStages: [
                {
                    _id: "sg-6VqohtwaZyLytC62lEWsj",
                    name: "Stage 2"
                }
            ],
            prevStages: [],
            nextStageIds: ["sg-6VqohtwaZyLytC62lEWsj"],
            prevStageIds: [],
            dueDate: null,
            onEnter: {
                explicit_deny: [
                    {
                        subject: "1",
                        kind: "User",
                        permission: "view",
                        scope: "document",
                        subjectData: { firstname: "John", lastname: "Doe" }
                    },
                    {
                        subject: "2",
                        kind: "User",
                        permission: "edit",
                        scope: "document",
                        subjectData: { firstname: "Will", lastname: "Smith" }
                    },
                ],
                createActions: [
                    {
                        displayname: null,
                        name: "My action 1",
                        displaytype: null,
                        description: null,
                        identifier: "test123",
                        subject: [
                            {
                                id: "14de9ac2-f7d1-446a-bb27-4bbf47b860bb",
                                kind: "User",
                                assignee: {
                                    __typename: "User",
                                    firstname: "Test",
                                    lastname: "Admin" 
                                }
                            },
                            {
                                id: "14de9ac2-f7d1-446a-bb27-4bbf47b860b3",
                                kind: "ProjectGroup",
                                assignee: {
                                    __typename: "ProjectGroup",
                                    displayName: "Editors"
                                }
                            },
                        ],
                        sendNotification: true,
                        customstati: [ "x1", "x2" ]
                    }
                ]
            },
            defaultActionType: "APPROVE",
            entryguards: [],
            exitguards: [
                {
                    nextStage: "sg-ZCBIMty4bAz7YVF1WcwuE",
                    conditions: [
                        {
                            assertation: {
                                __typename: "ActionAssertation",
                                customstatus: "Approve",
                                type: "APPROVE",
                                status: "FULFILLED",
                                actionIdentifier: "test123"
                            }
                        },
                    ]
                },
                {
                    nextStage: {
                        _id: "sg-6VqohtwaZyLytC62lEWsj",
                        name: "Stage 2",
                        description: null,
                        nextStages: [
                            {
                                _id: "sg-A61xEtIteGpW6aqffBKYZ",
                                name: "Stage 1"
                            }
                        ],
                        prevStages: [],
                        nextStageIds: ["sg-A61xEtIteGpW6aqffBKYZ"],
                        prevStageIds: [],
                        dueDate: null,
                        onEnter: { explicit_deny: [],
                            createActions: [
                                {
                                    displayname: null,
                                    name: "My action 1",
                                    displaytype: null,
                                    description: null,
                                    identifier: null,
                                    subject: [
                                        {
                                            id: "14de9ac2-f7d1-446a-bb27-4bbf47b860bb",
                                            kind: "User",
                                            assignee: {
                                                __typename: "User",
                                                firstname: "Test",
                                                lastname: "Admin" 
                                            }
                                        },
                                        {
                                            id: "14de9ac2-f7d1-446a-bb27-4bbf47b860b3",
                                            kind: "ProjectGroup",
                                            assignee: {
                                                __typename: "ProjectGroup",
                                                displayName: "Editors"
                                            }
                                        },
                                    ],
                                    sendNotification: true,
                                    customstati: [ "x1", "x2" ]
                                }
                            ]},
                        defaultActionType: "CLEARED",
                        entryguards: [],
                        exitguards: [],
                        autoprogress: []
                    },
                    conditions: [
                        {
                            assertation: {
                                __typename: "ActionAssertation",
                                customstatus: "Send to Done",
                                type: "APPROVE",
                                status: "REJECTED"
                            }
                        },
                    ]
                }
            ],
            autoprogress: [
                {
                    nextStage: {
                        _id: "sg-6VqohtwaZyLytC62lEWsj",
                        name: "Stage 2",
                        description: null,
                        nextStages: [
                            {
                                _id: "sg-A61xEtIteGpW6aqffBKYZ",
                                name: "Stage 1"
                            }
                        ],
                        prevStages: [],
                        nextStageIds: ["sg-A61xEtIteGpW6aqffBKYZ"],
                        prevStageIds: [],
                        dueDate: null,
                        onEnter: { explicit_deny: [],
                            createActions: [
                                {
                                    displayname: null,
                                    name: "My action 1",
                                    displaytype: null,
                                    description: null,
                                    identifier: null,
                                    subject: [
                                        {
                                            id: "14de9ac2-f7d1-446a-bb27-4bbf47b860bb",
                                            kind: "User",
                                            assignee: {
                                                __typename: "User",
                                                firstname: "Test",
                                                lastname: "Admin" 
                                            }
                                        },
                                        {
                                            id: "14de9ac2-f7d1-446a-bb27-4bbf47b860b3",
                                            kind: "ProjectGroup",
                                            assignee: {
                                                __typename: "ProjectGroup",
                                                displayName: "Editors"
                                            }
                                        },
                                    ],
                                    sendNotification: true,
                                    customstati: [ "x1", "x2" ]
                                }
                            ]},
                        defaultActionType: "CLEARED",
                        entryguards: [],
                        exitguards: [],
                        autoprogress: []
                    },
                    nextStageId: "sg-6VqohtwaZyLytC62lEWsj",
                    conditions: [
                        {
                            assertation: {
                                __typename: "ActionAssertation"
                            },
                            name: "Progress to b if one REVIEW has taken place",
                            description: null
                        }
                    ]
                }
            ]
        },
        {
            _id: "sg-6VqohtwaZyLytC62lEWsj",
            name: "Stage 2",
            description: null,
            nextStages: [
                {
                    _id: "sg-A61xEtIteGpW6aqffBKYZ",
                    name: "Stage 1"
                }
            ],
            prevStages: [],
            nextStageIds: ["sg-A61xEtIteGpW6aqffBKYZ"],
            prevStageIds: [],
            dueDate: null,
            onEnter: {
                explicit_deny: [],
                createActions: []
            },
            defaultActionType: "CLEARED",
            entryguards: [],
            exitguards: [],
            autoprogress: []
        }
    ],
    log: {
        root: "6cb5c23f-23de-4a67-b973-a4c0c5a40ff8",
        data: [
            {
                index: 1,
                timestamp: 1619065886495,
                data: {
                    comment: "Lets rework this later, but move on for now",
                    who: {
                        id: "18e09fe5-c8a8-4896-b4f4-c10da9cd9ae0",
                        email: "testadmin@mailtest.masterdocs.com.au",
                        firstname: "Test",
                        lastname: "Admin"
                    },
                    why: {
                        human: "Initilized log on Hello Workflow (6080fc1e3365555ae94a59e5)",
                        robot: {
                            related: "1",
                            relatedKind: "action",
                            action: {
                                kind: "APPROVE",
                                status: "FULFILLED"
                            }
                        }
                    },
                    what: [],
                    when: 1619092521445
                },
                hash: "c80062169db44a780cc75928803d8092b8b3658ec20f901fb2fee5a3fb14b8f5"
            },
        ]
    },
    etag: "1",
    currentStage: {
        _id: "sg-A61xEtIteGpW6aqffBKYZ",
        name: "Stage 1",
        PlannedEnd: "2021-05-22T04:31:26.493Z",
        exitguards: [
            {
                nextStage: {
                    _id: "sg-6VqohtwaZyLytC62lEWsj",
                    name: "Stage 2",
                    description: null,
                    nextStages: [
                        {
                            _id: "sg-A61xEtIteGpW6aqffBKYZ",
                            name: "Stage 1"
                        }
                    ],
                    prevStages: [],
                    nextStageIds: ["sg-A61xEtIteGpW6aqffBKYZ"],
                    prevStageIds: [],
                    dueDate: null,
                    onEnter: { explicit_deny: [],
                        createActions: [
                            {
                                displayname: null,
                                name: "My action 1",
                                displaytype: null,
                                description: null,
                                identifier: null,
                                subject: [
                                    {
                                        id: "14de9ac2-f7d1-446a-bb27-4bbf47b860bb",
                                        kind: "User",
                                        assignee: {
                                            __typename: "User",
                                            firstname: "Test",
                                            lastname: "Admin" 
                                        }
                                    },
                                    {
                                        id: "14de9ac2-f7d1-446a-bb27-4bbf47b860b3",
                                        kind: "ProjectGroup",
                                        assignee: {
                                            __typename: "ProjectGroup",
                                            displayName: "Editors"
                                        }
                                    },
                                ],
                                sendNotification: true,
                                customstati: [ "x1", "x2" ]
                            }
                        ]},
                    defaultActionType: "CLEARED",
                    entryguards: [],
                    exitguards: [],
                    autoprogress: []
                },
                conditions: [
                    {
                        assertation: {
                            __typename: "ActionAssertation",
                            customstatus: "Approve",
                            type: "APPROVE",
                            status: "FULFILLED",
                            actionIdentifier: "test123"
                        }
                    },
                ]
            },
            {
                nextStage: {
                    _id: "sg-6VqohtwaZyLytC62lEWsj",
                    name: "Stage 2",
                    description: null,
                    nextStages: [
                        {
                            _id: "sg-A61xEtIteGpW6aqffBKYZ",
                            name: "Stage 1"
                        }
                    ],
                    prevStages: [],
                    nextStageIds: ["sg-A61xEtIteGpW6aqffBKYZ"],
                    prevStageIds: [],
                    dueDate: null,
                    onEnter: { explicit_deny: [],
                        createActions: [
                            {
                                displayname: null,
                                name: "My action 1",
                                displaytype: null,
                                description: null,
                                identifier: "test123",
                                subject: [
                                    {
                                        id: "14de9ac2-f7d1-446a-bb27-4bbf47b860bb",
                                        kind: "User",
                                        assignee: {
                                            __typename: "User",
                                            firstname: "Test",
                                            lastname: "Admin" 
                                        }
                                    },
                                    {
                                        id: "14de9ac2-f7d1-446a-bb27-4bbf47b860b3",
                                        kind: "ProjectGroup",
                                        assignee: {
                                            __typename: "ProjectGroup",
                                            displayName: "Editors"
                                        }
                                    },
                                ],
                                sendNotification: true,
                                customstati: [ "x1", "x2" ]
                            }
                        ]},
                    defaultActionType: "CLEARED",
                    entryguards: [],
                    exitguards: [],
                    autoprogress: []
                },
                conditions: [
                    {
                        assertation: {
                            __typename: "ActionAssertation",
                            customstatus: "Send to Done",
                            type: "APPROVE",
                            status: "REJECTED",
                            actionIdentifier: "test123"
                        }
                    },
                ]
            }
        ],
        nextStages: [
            {
                _id: "sg-6VqohtwaZyLytC62lEWsj",
                name: "Stage 2",
                description: null,
                nextStages: [
                    {
                        _id: "sg-A61xEtIteGpW6aqffBKYZ",
                        name: "Stage 1"
                    }
                ],
                prevStages: [],
                nextStageIds: ["sg-A61xEtIteGpW6aqffBKYZ"],
                prevStageIds: [],
                dueDate: null,
                onEnter: {
                    explicit_deny: [],
                    createActions: [
                        {
                            displayname: null,
                            name: "My action 1",
                            displaytype: null,
                            description: null,
                            identifier: null,
                            subject: [
                                {
                                    id: "14de9ac2-f7d1-446a-bb27-4bbf47b860bb",
                                    kind: "User",
                                    assignee: {
                                        __typename: "User",
                                        firstname: "Test",
                                        lastname: "Admin" 
                                    }
                                },
                                {
                                    id: "14de9ac2-f7d1-446a-bb27-4bbf47b860b3",
                                    kind: "ProjectGroup",
                                    assignee: {
                                        // eslint-disable-next-line max-lines
                                        __typename: "ProjectGroup",
                                        displayName: "Editors"
                                    }
                                },
                            ],
                            sendNotification: true,
                            customstati: [ "x1", "x2" ]
                        }
                    ]
                },
                defaultActionType: "CLEARED",
                entryguards: [],
                exitguards: [],
                autoprogress: []
            }
        ],
        onEnter: {
            explicit_deny: [],
            createActions: [
                {
                    displayname: null,
                    name: "My action 1",
                    displaytype: null,
                    description: null,
                    identifier: null,
                    subject: [
                        {
                            id: "14de9ac2-f7d1-446a-bb27-4bbf47b860bb",
                            kind: "User",
                            assignee: {
                                __typename: "User",
                                firstname: "Test",
                                lastname: "Admin" 
                            }
                        },
                        {
                            id: "14de9ac2-f7d1-446a-bb27-4bbf47b860b3",
                            kind: "ProjectGroup",
                            assignee: {
                                __typename: "ProjectGroup",
                                displayName: "Editors"
                            }
                        },
                    ],
                    sendNotification: true,
                    customstati: [ "x1", "x2" ]
                }
            ]
        },
    },
    workflowmodelid: "6080fc1e3365555ae94a59e5",
    workflowmodel: {
        _id: "6080fc1e3365555ae94a59e5",
        name: "Hello Workflow"
    },
    _parent: {
        _id: "v2/dar/document/1234",
        model: "v2document"
    },
    currentStageStartDate: "2021-04-22T04:31:26.493Z",
    myactions: {
        edges: [
            { node: {
                action: {
                    kind: "APPROVE",
                    status: "PENDING",
                    name: "APPROVE DOC ID 1",
                    displayName: "Approve",
                    customstati: [ "Approve", "Send to Done" ]
                }
            } },
            { node: {
                action: {
                    kind: "REVIEW",
                    status: "PENDING",
                    name: "REVIEW DOC ID 2",
                    displayName: "Pass review"
                }
            } }
        ]
    },
    actions: {
        edges: []
    }
};

export const hasApproved = clone(requiresApproval);
hasApproved.myactions.edges[0].node.action.status = "FULFILLED";
hasApproved.log.data = [...approvalLogItems];

export const hasRejected = clone(requiresApproval);
hasRejected.myactions.edges[0].node.action.status = "REJECTED";
hasRejected.log.data = [...approvalLogItems];

export const author = clone(requiresApproval);
author.log.data = [];
author.myactions = { edges: []};

export const admin = clone(requiresApproval);
admin.log.data = [];
admin.myactions = { edges: []};
